<app-churning-status [pending]="(getReactivationRequestHttpPackage$ | async).result !== null"> </app-churning-status>
